import { useEffect } from 'react'
import { CountryCode } from '@kenno/resources'

import { shouldShowBicField } from 'views/TerminateContract/utils/bankCountry'

export const useBicField = (
  bankCountryCode: CountryCode | null,
  iban: string | null,
  bic: string | null,
  bicFieldName: string,
  setFieldValue: (field: string, value: string | null) => void
) => {
  const isBicFieldVisible = shouldShowBicField(bankCountryCode, iban)

  useEffect(() => {
    if (!isBicFieldVisible && bic !== null) {
      setFieldValue(bicFieldName, null)
    }
  }, [isBicFieldVisible, bic, bicFieldName, setFieldValue])

  return {
    isBicFieldVisible,
  }
}
